<template>
    
  <form @submit.prevent="save">

    <div class="form-group">
        <label>Nombre de la columna</label>
        <input type="text" v-model="model.nombre" class="form-control" placeholder="Escribe el nombre de la columna"/>
    </div>
    <div class="form-group">
        <label>Palabra clave</label>
        <input type="text" v-model="model.clave" class="form-control" placeholder="Escribe la palabra clave de la columna"/>
    </div>

    <!--
    <div class="form-group">
        <label>Slug</label>
        <input type="text" v-model="model.slug" class="form-control" placeholder="Escribe el slug de la columna"/>
    </div>-->
    <div class="form-group">
        <label><input type="checkbox" true-value="1" false-value="0" v-model="model.activo"/> Activo</label> 
    </div>


    <input type="submit" class="btn btn-info" value="Guardar"/>

    <router-link class="btn btn-clean" :to="{path:'/columnas'}">Cancelar</router-link>

  </form>



</template>


<script>


import api from '@/util/api.js';



export default{

    name:"formColumna",
    components:{
        


    },

    props:{

      id:{
        type:Number,
        required:false,
      }
    },
    data(){

      return{

        isNewRecord:true,
        model:{nombre:'',clave:'',activo:1,slug:''}

      }

      },


    methods:{

      save(){

        
              api.request(
              {url:this.isNewRecord?'/columnas':'/columnas/'+this.$props.id,
              data:this.createFormData(this.model),
              method:this.isNewRecord?'POST':'PATCH',
              }).then(()=>{


                  this.$router.push('/columnas');
                  

              }).catch(error=>{

                console.log(error);

              });


              


      }

    },

    mounted()
    {



      const id=this.$props.id;
      if(id){

        this.isNewRecord=false;


        api.get('/columnas/'+id,this.createFormData(this.model)).then(response=>{

          this.fillModel(this.model,response.data.item);



          }).catch(error=>{

          console.log(error);

          });

      }


    }


}

</script>